import React, { useEffect, useRef, useState } from 'react';

import Icon from '@components/Icon/Icon';

import {
  DropdownStyle,
  Option,
  Options,
  Selector,
} from './RoundedDropdown.style';

type OptionType = {
  value: boolean | number | string;
  text: string;
};

export default function RoundedDropdown({
  onChange,
  options = [],
  value = '',
}: {
  onChange?: (option: boolean | number | string) => void;
  options: OptionType[];
  value: boolean | number | string;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLInputElement>(null);
  const selectedOption = options.find((o) => o.value === value) ?? null;

  useEffect(() => {
    function handleClick(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClick, false);
    return () => {
      document.removeEventListener('mousedown', handleClick, false);
    };
  }, []);

  function handleChange(value: boolean | number | string) {
    if (onChange) {
      onChange(value);
    }
    setOpen(false);
  }

  return (
    <DropdownStyle className={open ? 'open' : ''} ref={ref}>
      <Selector onClick={() => setOpen(!open)}>
        {selectedOption?.text ?? ''}
        <Icon
          color="primary.contrastText"
          name="chevron-down"
          rotation={open ? 180 : 0}
        />
      </Selector>

      <Options className={open ? 'open' : ''}>
        {options.map(({ text, value }) => (
          <Option
            key={`time-dropdown-option-${value}`}
            onClick={() => handleChange(value)}
          >
            {text}
          </Option>
        ))}
      </Options>
    </DropdownStyle>
  );
}
